import { render } from "./AdminPanelHome.vue?vue&type=template&id=c7e80164"
import script from "./AdminPanelHome.vue?vue&type=script&lang=js"
export * from "./AdminPanelHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__